import React, { useState, useEffect , useMemo} from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import baseURL from "../../../../Url/NodeBaseURL";
import { toWords } from "number-to-words";

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 8,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 5,
  },
  tableCellHeader: {
    width: "4%",
    textAlign: "right",
    marginTop: "-4",
  },
  col: {
    flexDirection: "column",
  },
  boldText: {
    fontWeight: "bold",
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    textAlign: "right",
    letterSpacing: 2,
  },
  poNumber: {
    fontSize: 10,
    textAlign: "right",
  },
  textSmall: {
    fontSize: 8,
    marginBottom: 2,
  },
  sectionTitle: {
    fontWeight: "bold",
    marginTop: 10,
    marginBottom: 2,
  },
  tableHeader: {
    backgroundColor: "#3A3A3A",
    fontWeight: "bold",
    flexDirection: "row",
    padding: 4,
  },
  tableRow: {
    flexDirection: "row",
    padding: 4,
    borderBottomWidth: 1,
    borderBottomColor: "#ddd",
  },
  cell: {
    padding: 2,
    fontSize: 7,
  },
  cellHeader: {
    fontSize: 8,
    fontWeight: "bold",
  },
  logo: {
    height: 60,
    width: 180,
    marginBottom: 10,
  },
  companyInfo: {
    marginBottom: 15,
  },
});

const Salesorderform = ({
  formData,
  orderDetails,
  hsnMap,
  cash_amount,
  card_amt,
  chq_amt,
  online_amt,
  taxableAmount,
  taxAmount,
  discountAmt,
  festivalDiscountAmt,
  oldItemsAmount,
  schemeAmount,
  salesNetAmount,
  salesTaxableAmount,
  netAmount,
  netPayableAmount,
  advanceAmount,
}) => {
  const items = formData?.items || [];
  const currentTime = new Date().toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
  const [loading, setLoading] = useState(true); // State for loading
  const [error, setError] = useState(null); // State for error handling
  const [data, setData] = useState([]); // State to store table data
  const [totalDiscount, setTotalDiscount] = useState(0);

  useEffect(() => {
    const totalDiscount = orderDetails.reduce((acc, item) => {
      console.log("DEBUG individual item", item);
      const discount = parseFloat(item.disscount) || 0;
      return acc + discount;
    }, 0);
    setTotalDiscount(totalDiscount);
    console.log("DEBUG TOTAL DISCOUNT", totalDiscount);
  }, []);

  // const fetchProducts = async () => {
  //   try {
  //     const response = await fetch(`${baseURL}/get/products`);
  //     if (!response.ok) {
  //       throw new Error("Failed to fetch products");
  //     }
  //     const result = await response.json();
  //     setData(result);
  //   } catch (error) {
  //     setError(error.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // useEffect(() => {
  //   fetchProducts();
  // }, []);

  const totalValues = orderDetails.reduce(
    (totals, item) => {
      return {
        qty: totals.qty + Number(item.qty || 0),
        grossWeight: totals.grossWeight + Number(item.gross_weight || 0),
        stoneWeight: totals.stoneWeight + Number(item.stone_weight || 0),
        netWeight: totals.netWeight + Number(item.total_weight_av || 0),
        rate: totals.rate + Number(item.rate || 0),
        makingCharges: totals.makingCharges + Number(item.making_charges || 0),
        hmCharges: totals.hmCharges + Number(item.hm_charges || 0),
        stonePrice: totals.stonePrice + Number(item.stone_price || 0),
        rateAmount: totals.rateAmount + Number(item.rate_amt || 0),
        discount: totals.discount + Number(item.discount_amount || 0),
      };
    },
    {
      qty: 0,
      grossWeight: 0,
      stoneWeight: 0,
      netWeight: 0,
      rate: 0,
      makingCharges: 0,
      hmCharges: 0,
      stonePrice: 0,
      rateAmount: 0,
    }
  );

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const subTotal =
    totalValues.rateAmount +
    totalValues.makingCharges +
    totalValues.stonePrice +
    totalValues.hmCharges;
  const CGST = taxAmount / 2;
  const SGST = taxAmount / 2;
  let parsedAdvance = 0;
  try {
    if (typeof advanceAmount === "string") {
      const parsed = JSON.parse(advanceAmount);
      parsedAdvance = Array.isArray(parsed)
        ? parsed.reduce((acc, val) => acc + Number(val?.amount || val || 0), 0)
        : Number(parsed);
    } else if (Array.isArray(advanceAmount)) {
      parsedAdvance = advanceAmount.reduce(
        (acc, val) => acc + Number(val?.amount || val || 0),
        0
      );
    } else {
      parsedAdvance = Number(advanceAmount || 0);
    }
  } catch (e) {
    console.error("Failed to parse advanceAmount:", e); //debugging
  }

  const adjustedNetAmount =
    netAmount - oldItemsAmount - schemeAmount - salesNetAmount - parsedAdvance - (festivalDiscountAmt || 0);

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={{ marginTop: 20 }}>
          {/* Logo and Company Info */}
          <View style={styles.row}>
            <View style={{ width: "60%" }}>
              <Image
                style={[styles.logo, { marginTop: 10 }]}
                src="/sadashri_logo-bnw.png"
              />
              <View style={styles.companyInfo}>
                <Text style={[styles.boldText, styles.textSmall]}>
                  Sadashri Ventures Private Limited
                </Text>
                <Text style={styles.textSmall}>
                  Flat No: 1323/1324, 16th B Cross Hosing
                </Text>
                <Text style={styles.textSmall}>
                  Board Colony EWS 3rd Phase, Yelahanka New
                </Text>
                <Text style={styles.textSmall}>
                  Town, Bengaluru Urban, Karnataka- 560064
                </Text>
                <Text style={styles.textSmall}>
                  CIN : U46498KA2024PTC185784
                </Text>
                <Text style={styles.textSmall}>GSTIN: 29ABMCS9253K1ZG</Text>
                <Text style={styles.textSmall}>sadashri.Yel@gmail.com</Text>
              </View>
            </View>
            <View style={{ width: "40%", marginTop: 20 }}>
              <Text style={styles.title}>SALES ORDER</Text>
              <Text style={styles.poNumber}>{formData.order_number}</Text>
            </View>
          </View>
        </View>

        <View style={styles.col}>
          <View style={{ width: "80%" }}>
            <Text style={styles.sectionTitle}>Branch</Text>
            <Text style={styles.textSmall}>Sadashri Jewels</Text>
            <Text style={styles.textSmall}>
              Shop no. 1 No.2063, Dairy Circle, Asha Arcade,
            </Text>
            <Text style={styles.textSmall}>
              16th B Cross Rd, Yalahanka New Town, Bangalore- 560064
            </Text>
          </View>
        </View>
        <View
          style={[
            styles.row,
            { justifyContent: "space-between", marginTop: 10 },
          ]}
        >
          <View style={{ width: "55%" }}>
            <Text style={styles.sectionTitle}>Deliver To</Text>

            {formData.account_name && (
              <Text style={styles.textSmall}>{formData.account_name}</Text>
            )}
            {formData.address1 && (
              <Text style={styles.textSmall}>{formData.address1}</Text>
            )}
            {formData.address2 && (
              <Text style={styles.textSmall}>{formData.address2}</Text>
            )}
            {(formData.city || formData.state || formData.pincode) && (
              <Text style={styles.textSmall}>
                {[formData.city, formData.state, formData.pincode]
                  .filter(Boolean)
                  .join(", ")}
              </Text>
            )}
            <Text style={styles.textSmall}>India</Text>
            {formData.gst_in && (
              <Text style={styles.textSmall}>GSTIN {formData.gst_in}</Text>
            )}
            {formData.email && (
              <Text style={styles.textSmall}>{formData.email}</Text>
            )}
          </View>

          <View style={{ width: "25%", paddingLeft: 10, marginTop: 10 }}>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Text style={styles.textSmall}>Date : </Text>
              <Text style={styles.textSmall}>{formatDate(formData.date)}</Text>
            </View>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Text style={styles.textSmall}>Delivery Date :</Text>
              <Text style={styles.textSmall}>
                {formatDate(
                  new Date(formData.date).setDate(
                    new Date(formData.date).getDate() + 15
                  )
                )}
              </Text>
            </View>
          </View>
        </View>

        <View style={[styles.tableHeader]}>
          <Text style={[styles.cell, { width: "5%", color: "white" }]}>#</Text>
          <Text style={[styles.cell, { width: "20%", color: "white" }]}>
            Item & Description
          </Text>
          <Text style={[styles.cell, { width: "10%", color: "white" }]}>
            HSN/SAC
          </Text>
          <Text style={[styles.cell, { width: "5%", color: "white" }]}>
            Qty
          </Text>
          <Text style={[styles.cell, { width: "12%", color: "white" }]}>
            Purity
          </Text>
          <Text style={[styles.cell, { width: "10%", color: "white" }]}>
            Gross.wt
          </Text>
          <Text style={[styles.cell, { width: "7%", color: "white" }]}>
            St.wt
          </Text>
          <Text style={[styles.cell, { width: "10%", color: "white" }]}>
            Net.wt
          </Text>
          <Text style={[styles.cell, { width: "10%", color: "white" }]}>
            Rate
          </Text>
          <Text style={[styles.cell, { width: "7%", color: "white" }]}>
            V.A
          </Text>
          <Text style={[styles.cell, { width: "7%", color: "white" }]}>MC</Text>
          <Text style={[styles.cell, { width: "7%", color: "white" }]}>
            St.Amt
          </Text>
          <Text style={[styles.cell, { width: "15%", color: "white" }]}>
            Status
          </Text>
          <Text style={[styles.cell, { width: "10%", color: "white" }]}>
            Total
          </Text>
        </View>

        {orderDetails.map((item, index) => {
          const hsnCode = hsnMap[item.category] || "";
          console.log("DEBUG ITEM category name", item.category, "HSN:", hsnCode);

          return (
            <View
              style={[
                styles.tableRow,
                { fontFamily: "Times-Roman", flexDirection: "row" },
              ]}
              key={index}
            >
              <Text style={[styles.cell, { width: "5%" }]}>{index + 1}</Text>
              <Text style={[styles.cell, { width: "20%", color: "#666" }]}>
                {item.metal_type || ""} - {item.product_name || ""}
                {item.remarks_type === "Client Facing" && item.remarks
                  ? ` (${item.remarks})`
                  : ""}
              </Text>
              <Text style={[styles.cell, { width: "10%" }]}>
                {hsnCode ? String(hsnCode) : "-"}
              </Text>
              <Text style={[styles.cell, { width: "5%" }]}>
                {item.qty || "1"}
              </Text>
              <Text style={[styles.cell, { width: "12%" }]}>
                {item.printing_purity || ""}
              </Text>
              <Text style={[styles.cell, { width: "10%" }]}>
                {item.gross_weight || ""}
              </Text>
              <Text style={[styles.cell, { width: "7%" }]}>
                {item.stone_weight || ""}
              </Text>
              <Text style={[styles.cell, { width: "10%" }]}>
                {item.total_weight_av || ""}
              </Text>
              <Text style={[styles.cell, { width: "10%" }]}>
                {item.pieace_cost ? item.pieace_cost : item.rate}
              </Text>
              <Text style={[styles.cell, { width: "7%" }]}>
                {item.va_percent || ""}
              </Text>
              <Text style={[styles.cell, { width: "7%" }]}>
                {item.mc_per_gram != null && item.mc_per_gram !== ""
                  ? ["gold", "diamond", "others"].includes(
                      item.metal_type?.toLowerCase()
                    )
                    ? `${parseFloat(item.mc_per_gram).toFixed(2)} %`
                    : parseFloat(item.mc_per_gram).toFixed(2)
                  : ""}
              </Text>
              <Text style={[styles.cell, { width: "7%" }]}>
                {item.stone_price || ""}
              </Text>
              <Text style={[styles.cell, { width: "15%" }]}>
                {item.reservation_status || ""}
                {item.reservation_status ? "\n" : ""}
                {item.order_status === "In Progress"
                  ? "Not Delivered"
                  : item.order_status || ""}
              </Text>

              <Text style={[styles.cell, { width: "10%" }]}>
                {(
                  parseFloat(item.rate_amt || 0) +
                  parseFloat(item.stone_price || 0) +
                  parseFloat(item.making_charges || 0) +
                  parseFloat(item.hm_charges || 0)
                ).toFixed(2) || "0.00"}
              </Text>
            </View>
          );
        })}

        <View style={[styles.row, { marginTop: 20 }]}>
          <View style={{ width: "70%" }} />
          <View style={{ width: "30%", paddingLeft: 10 }}>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 5,
              }}
            >
              <Text style={styles.textSmall}>Sub Total :</Text>
              <Text style={styles.textSmall}>{subTotal.toFixed(2)}</Text>
            </View>
            {discountAmt !== 0 && (
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginBottom: 5,
                }}
              >
                <Text style={styles.textSmall}>(-)Discount :</Text>
                <Text style={styles.textSmall}>
                  {discountAmt.toFixed(2) || totalDiscount}
                </Text>
              </View>
            )}
            {totalDiscount !== 0 && (
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginBottom: 5,
                }}
              >
                <Text style={styles.textSmall}>(-)Discount :</Text>
                <Text style={styles.textSmall}>{totalDiscount}</Text>
              </View>
            )}
            {(festivalDiscountAmt || 0) !== 0 && (
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginBottom: 5,
                }}
              >
                <Text style={styles.textSmall}>(-)Festival Offer :</Text>
                <Text style={styles.textSmall}>{(festivalDiscountAmt || 0).toFixed(2)}</Text>
              </View>
            )}
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 5,
              }}
            >
              <Text style={styles.textSmall}>SGST:</Text>
              <Text style={styles.textSmall}>{SGST.toFixed(2)}</Text>
            </View>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 5,
              }}
            >
              <Text style={styles.textSmall}>CGST:</Text>
              <Text style={styles.textSmall}>{CGST.toFixed(2)}</Text>
            </View>

            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 5,
              }}
            >
              <Text style={[styles.textSmall]}>Net Bill Value:</Text>
              <Text style={[styles.textSmall]}>{netAmount.toFixed(2)}</Text>
            </View>

            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 5,
              }}
            >
              <Text style={[styles.textSmall]}>(-)Old Items Amt:</Text>
              <Text style={[styles.textSmall]}>
                {oldItemsAmount.toFixed(2)}
              </Text>
            </View>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 5,
              }}
            >
              <Text style={[styles.textSmall]}>(-)Scheme Amt:</Text>
              <Text style={[styles.textSmall]}>{schemeAmount.toFixed(2)}</Text>
            </View>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 5,
              }}
            >
              <Text style={[styles.textSmall]}>(-)Sale Return Amt:</Text>
              <Text style={[styles.textSmall]}>
                {salesNetAmount.toFixed(2)}
              </Text>
            </View>

            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 5,
              }}
            >
              <Text style={[styles.textSmall]}>Advance:</Text>
              <Text style={[styles.textSmall]}>{parsedAdvance.toFixed(2)}</Text>
            </View>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 5,
              }}
            >
              <Text style={[styles.textSmall, { fontWeight: "bold" }]}>
                Net Amount:
              </Text>
              <Text style={[styles.textSmall, { fontWeight: "bold" }]}>
                {Math.round(adjustedNetAmount).toFixed(2)}
              </Text>
            </View>
          </View>
        </View>

        <View style={[styles.row, { marginTop: 40 }]}>
          <Text>
            Authorized Signature{" "}
            <Text style={{ fontWeight: "bold" }}>____________________</Text>
          </Text>
          <Text>
            Sadashri Ventures Signature{" "}
            <Text style={{ fontWeight: "bold" }}>____________________</Text>
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default Salesorderform;
